module.exports = __webpack_public_path__ + "img/p13.13624c9e.png";